// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"Z4-z"};